import n from "react";
import i from "@mui/material/Breadcrumbs";
import m from "@mui/material/Link";
import o from "@mui/material/Typography";
function l(e) {
  return /* @__PURE__ */ n.createElement(m, { ...e });
}
function h(e) {
  var a;
  return /* @__PURE__ */ n.createElement(
    i,
    {
      id: e.id,
      maxItems: e.maxItems ? e.maxItems : 5,
      separator: "/",
      "aria-label": e["aria-label"]
    },
    (a = e.breadcrumbs) == null ? void 0 : a.map((t, r) => r + 1 === e.breadcrumbs.length ? /* @__PURE__ */ n.createElement(o, { key: r }, t.text) : "component" in e && "to" in t ? /* @__PURE__ */ n.createElement(
      l,
      {
        component: e.component,
        to: t.to,
        key: t.to,
        "aria-current": "page"
      },
      t.text
    ) : "href" in t ? /* @__PURE__ */ n.createElement(m, { key: r, href: t.href, "aria-current": "page" }, t.text) : null)
  );
}
export {
  h as B
};
